import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MainLayoutComponent } from '@doa/core/shell/main-layout/main-layout.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { RedirectComponent } from './features/redirect/redirect.component';
import { SessionExpiredComponent } from './features/session-expired/session-expired.component';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/app-redirect',
    pathMatch: 'full'
  },
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: 'home',
        loadChildren: () => import('./features/home/home.module').then(m => m.HomeModule)  // lazy loading
      },
      { 
        path: 'mydoa',
        loadChildren: () => import('./features/mydoa/mydoa.module').then(m => m.MyDoaModule) 
      },
      {
        path:'search',
        loadChildren: () => import('./features/search/search.module').then(m => m.SearchModule)
      },
      {
        path:'actions',
        loadChildren: () => import('./features/doa-request/doa-request.module').then(m => m.DoaRequestModule)
      },
      {
        path:'mytask',
        loadChildren: () => import('./features/doa-manager/dao-manager.module').then(m => m.DoaManagerModule)
      },
      {
        path:'admin',
        loadChildren: () => import('./features/admin/admin.module').then(m => m.AdminModule)
      },
      {
        path:'help',
        loadChildren: () => import('./features/help/help.module').then(m => m.HelpModule)
      },
      {
        path: 'recertification',
        loadChildren: () => import('./features/recertification/recertification.module').then(m => m.RecertificationModule)
      }
    ]
  },
  {
    path: 'app-redirect',
    component: RedirectComponent,
    pathMatch: 'full'
  },
  {
    path: 'unauthorized',
    component: UnauthorizedComponent,
    pathMatch: 'full'
  },
  {
    path: 'session-expired',
    component: SessionExpiredComponent,
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
